import { render } from "./CopyPoint.vue?vue&type=template&id=d6554284&scoped=true"
import script from "./CopyPoint.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CopyPoint.vue?vue&type=script&charset=utf-8&lang=js"

import "./CopyPoint.vue?vue&type=style&index=0&id=d6554284&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6554284"]])

export default __exports__